import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface AutonomyCategory { category: string; sae_level: number; consecutive_successes: number; last_promoted_at: string | null; last_demoted_at: string | null; }

export function useAutonomy() {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [categories, setCategories] = useState<AutonomyCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ categories: AutonomyCategory[] }>('/api/dashboard/autonomy', token)
      .then((d) => { if (!cancelled) { setCategories(d.categories || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, refreshKey, logout]);

  return { categories, loading };
}
